import { render, staticRenderFns } from "./app-links.vue?vue&type=template&id=11d1cc9c"
import script from "./app-links.vue?vue&type=script&lang=js"
export * from "./app-links.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports